import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  transactions: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the transactions
export const fetchTransactions = createAsyncThunk(
  "fetchTransactions/transactions",
  async ({ enqueueSnackbar, limit = 100, page = 0, search }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`trips`, {
        params: {
          page: page + 1,
          limit,
          status: "completed",
          ...(search !== "" && {
            search,
          }),
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const transactionslice = createSlice({
  name: "transaction",
  initialState,
  extraReducers: (builder) => {
    // TODO: create transaction
    builder.addCase(fetchTransactions.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchTransactions.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.transactions = action.payload;
    });

    builder.addCase(fetchTransactions.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });
  },
});

export default transactionslice.reducer;
